declare global {
  interface RouterMeta {
    title: string;
  }
  interface Router {
    path: string;
    name: string;
    icon?: string;
    permission?: string;
    meta?: RouterMeta;
    component: any;
    children?: Array<Router>;
  }
  interface System {
    import(request: string): Promise<any>;
  }
  var System: System;
}
import main from '../views/main.vue';
import home from '../views/pages/home.vue';
import flightSearch from '../views/pages/flightSearch.vue';
import flight from '../views/pages/flight.vue';
import flightPayment from '../views/pages/flightPayment.vue';
import ticketDetail from '../views/pages/ticketDetail.vue';
import paymentFailed from '../views/pages/paymentFailed.vue';
import transferSearch from '../views/pages/transferSearch.vue';
import transferPayment from '../views/pages/transferPayment.vue';
import transferDetail from '../views/pages/transferDetail.vue';

export const otherRouters: Router = {
  path: '/',
  name: 'main',
  permission: '',
  meta: { title: 'ManageMenu' },
  component: main,
  children: [],
};

export const appRouters: Array<Router> = [
  {
    path: '/',
    name: 'pages',
    permission: '',
    meta: { title: 'ManageMenu' },
    icon: '&#xe68a;',
    component: main,
    children: [
      {
        path: '/',
        meta: { title: 'HomePage' },
        name: 'home',
        component: () => import('../views/pages/home.vue'),
      },
      {
        path: '/flightSearch/:id',
        meta: { title: 'Flight Search' },
        name: 'flightSearch',
        component: () => import('../views/pages/flightSearch.vue'),
      },
      {
        path: '/flightSearch/',
        meta: { title: 'Flight Search' },
        name: 'flightSearch',
        component: () => import('../views/pages/flightSearch.vue'),
      },
      {
        path: 'flight',
        meta: { title: 'Flight' },
        name: 'flight',
        component: () => import('../views/pages/flight.vue'),
      },
      {
        path: 'flightPayment/:searchId/:flightId',
        meta: { title: 'Flight Payment' },
        name: 'flightPayment',
        component: () => import('../views/pages/flightPayment.vue'),
      },
      {
        path: 'flightPayment/:searchId/:flightId/:returnFlightId',
        meta: { title: 'Flight Payment' },
        name: 'flightPayment',
        component: () => import('../views/pages/flightPayment.vue'),
      },
      {
        path: 'flightPayment',
        meta: { title: 'Flight Payment' },
        name: 'flightPayment',
        component: () => import('../views/pages/flightPayment.vue'),
      },
      {
        path: 'flight/:searchId/:flightId',
        meta: { title: 'Flight Payment' },
        name: 'flight',
        component: () => import('../views/pages/flightPayment.vue'),
      },
      {
        path: 'flight/:searchId/:flightId/:returnFlightId',
        meta: { title: 'Flight Payment' },
        name: 'flight',
        component: () => import('../views/pages/flightPayment.vue'),
      },
      {
        path: 'flight',
        meta: { title: 'Flight Payment' },
        name: 'flight',
        component: () => import('../views/pages/flightPayment.vue'),
      },
      {
        path: 'ticketDetail/:orderId',
        meta: { title: 'Ticket Detail' },
        name: 'ticketDetail',
        component: () => import('../views/pages/ticketDetail.vue'),
      },
      {
        path: 'paymentFailed',
        meta: { title: 'Payment Failed' },
        name: 'paymentFailed',
        component: () => import('../views/pages/paymentFailed.vue'),
      },
      {
        path: 'aboutUs',
        meta: { title: 'About Us' },
        name: 'aboutUs',
        component: () => import('../views/pages/about.vue'),
      },
      {
        path: 'contact',
        meta: { title: 'Contact Us' },
        name: 'contact',
        component: () => import('../views/pages/contact.vue'),
      },
      {
        path: 'help',
        meta: { title: 'Help Support' },
        name: 'help',
        component: () => import('../views/pages/help.vue'),
      },

      {
        path: '/transferSearch/:id',
        meta: { title: 'Transfer Search' },
        name: 'transferSearch',
        component: () => import('../views/pages/transferSearch.vue'),
      },
      {
        path: '/transferSearch/',
        meta: { title: 'Transfer Search' },
        name: 'transferSearch',
        component: () => import('../views/pages/transferSearch.vue'),
      },

      {
        path: '/transferPayment/:searchId/:transferId',
        meta: { title: 'Transfer Payment' },
        name: 'transferPayment',
        component: () => import('../views/pages/transferPayment.vue'),
      },
      {
        path: '/transferPayment/',
        meta: { title: 'Transfer Payment' },
        name: 'transferPayment',
        component: () => import('../views/pages/transferPayment.vue'),
      },
      {
        path: '/transferDetail/:orderId',
        meta: { title: 'Transfer Detail' },
        name: 'transferPayment',
        component: () => import('../views/pages/transferDetail.vue'),
      }
    ],
  },
];

export const routers = [...appRouters, otherRouters];
